<template>
  <section class="bioform" id="form">
    <div class="bioform__content --form">
      <div class="bioform__content--form container">
        <div class="monday-form">
          <iframe src="https://forms.monday.com/forms/embed/5b95cb961689b786b80ddc673ca5dbd1?r=use1"
            frameborder="0"
            class="monday-iframe">
          </iframe>
        </div>
      </div>
    </div>
    <div class="bioform__content --bio">
      <div class="bioform__content--info container">
        <div class="bioform__thumbnail --fade-in-up" data-vertical-ivp-class="--animate">
          <img src="@/assets/hero/CM.png" alt="Chris Miglino">
        </div>
        <h1 class="bioform__title --fade-in-up" data-vertical-ivp-class="--animate">
          Christopher Miglino
        </h1>
        <h2 class="bioform__subtitle --fade-in-up" data-vertical-ivp-class="--animate">
          Founder and CEO, SRAX - <a href="https://www.linkedin.com/in/miglino" target="_blank">linkedin.com/in/miglino</a>
        </h2>
        <p class="bioform__description --fade-in-up" data-vertical-ivp-class="--animate">
          Christopher Miglino stands at the forefront of technological innovation in investor relations,
          recognized as the entrepreneurial mind behind SRAX. His journey in the tech world is
          marked by the remarkable feat of founding three companies, each making their mark as publicly traded entities.
        </p>
        <p class="bioform__description --fade-in-up" data-vertical-ivp-class="--animate">
          At the core of Christopher's success is his profound understanding of the investor journey.
          His insights extend far beyond surface-level interactions, delving into the intricate dynamics
          of investor relations. This deep comprehension has been the driving force behind his creation
          of groundbreaking technologies designed to revolutionize how public companies interpret, manage,
          and communicate with their investors.
        </p>
        <p class="bioform__description --fade-in-up" data-vertical-ivp-class="--animate">
          Under Christopher's leadership, SRAX has emerged as a beacon in the technology sector, pioneering tools and
          platforms that empower public companies to connect with their investor base more effectively and transparently.
          His vision and expertise have not only propelled SRAX to new heights but have also significantly influenced the
          way public companies engage with their shareholders in an ever-evolving digital landscape.
        </p>
        <formbtn />
      </div>
    </div>
  </section>
</template>
  
  <script>
  export default {
    name: 'bioform',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/bioform.scss";
  </style>
  